import React from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import {receivableCustomerPieEchart} from "../../Data/Charts";

class ReceivableByCustomerPieChart extends React.Component {
  componentDidMount() {
    this.chartPlace();
  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.receivablesCustomersChartData !== this.props.receivablesCustomersChartData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const {receivablesCustomersChartData} = this.props


    const pieChartData = receivablesCustomersChartData.map(item => {
      const remaining = item.remaining_amount;
      const collected = item.total_receivable_amount - remaining;
      return {
        name: `${item.customer_name} ${item.customer_surname}`,
        value: remaining,
        total_amount: item.total_receivable_amount,
        remaining_amount: remaining,
        collected_amount: collected
      };
    });

    const optionPieEchart = receivableCustomerPieEchart(pieChartData);

    var chartDom = document.getElementById("ReceivableByCustomerPieChart");
    var myChart = echarts.init(chartDom);
    var option;
    option = optionPieEchart;

    option && myChart.setOption(option);
  };
  render() {
    return (
      <div>

          <div className="body">
            <div id="ReceivableByCustomerPieChart" style={{ height: 300 }}></div>
            {/* <ReactEcharts
                        option={optionPieEchart}
                        opts={{renderer: 'svg'}} // use svg to render the chart.
                    /> */}
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  receivablesCustomersChartData: state.analyticalReducer.receivablesCustomersChartData,
});

export default connect(mapStateToProps, {})(ReceivableByCustomerPieChart);
